import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { SaveButton } from '~/components/button';
import { FormLayout } from '~/components/settings';
import { useAppContext } from '~/contexts';
import type { DeviceServicesPage__Device } from '../../queries/Services.generated';
import { ActionBar, useServicesForm } from '../lib';

export interface ServicesFormProps {
  device: DeviceServicesPage__Device;
}

export const ServicesForm = ({ device }: ServicesFormProps) => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();
  const { edgeServicesSettings, formik, systemSettings, venueIntegrationsSettings } =
    useServicesForm({ device });

  if (!currentNetwork.canManage.value) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
        <Typography variant="subtitle1" color="text.secondary" sx={{ mr: 'auto' }}>
          {t('pages.devices.show.services.intro')}
        </Typography>
        <ActionBar>
          <SaveButton disabled={!formik.isValid || formik.isSubmitting} type="submit">
            {t('common.actions.save')}
          </SaveButton>
        </ActionBar>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
        {systemSettings.length > 0 && (
          <FormLayout
            formHeading={t('pages.devices.show.services.system_heading')}
            formData={systemSettings}
          />
        )}
        {edgeServicesSettings.length > 0 && (
          <FormLayout
            formHeading={t('pages.devices.show.services.edge_services_heading')}
            formData={edgeServicesSettings}
          />
        )}
        {venueIntegrationsSettings.length > 0 && (
          <FormLayout
            formHeading={t('pages.devices.show.services.venue_integrations_heading')}
            formData={venueIntegrationsSettings}
          />
        )}
      </Box>
    </form>
  );
};
